import React, { Component } from "react";
import { Link } from "react-router-dom";
import { CgMenuRight, CgMenuLeft } from "react-icons/cg";
import {
  Breadcrumb,
  BreadcrumbItem,
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
} from "reactstrap";
import header from "../../assets/imgs/header_bg.png";
import shopping_cart from "../../assets/imgs/shopping_cart.png";
import navbar_profile from "../../assets/imgs/navbar_profile.png";
import { connect } from "react-redux";
import { logout } from "../../redux/actions/authActions";

class Header extends Component {
  state = {
    navbarCollapse: false,
    profile: false,
  };
  toggleNav = () => {
    this.setState({
      navbarCollapse: !this.state.navbarCollapse,
    });
  };
  noOfItemsInCart = () => {
    let cart = JSON.parse(localStorage.getItem("cart"));
    if (cart != null) return cart.length;
    return 0;
  };
  toggle = () => {
    this.setState({
      profile: !this.state.profile,
    });
  };
  getUser = () => {
    let user = JSON.parse(localStorage.getItem("user_info"));
    return user;
  };
  componentDidMount() {
    if (this.props.location.pathname == "/")
      window.onscroll = function () {
        var currentScrollPos = window.pageYOffset;
        var toggler = document.getElementById("navbar-toggler");
        if (currentScrollPos > 500) {
          document.getElementById("navbar").classList.remove("appear");
          document.getElementById("navbar").classList.add("disappear");
          if (toggler) {
            toggler.classList.add("text-white");
          }
        } else {
          document.getElementById("navbar").classList.remove("disappear");
          document.getElementById("navbar").classList.add("appear");
          if (toggler) {
            toggler.classList.remove("text-white");
          }
        }
      };
  }
  render() {
    return (
      <>
        <header
          id="navbar"
          style={
            this.props.background != false
              ? { backgroundImage: `url(${header})` }
              : {}
          }
          className={
            this.props.location.pathname == "/"
              ? this.props.bread == null
                ? "top-header fixed-top"
                : "top-header-no-height fixed-top"
              : this.props.bread == null
              ? "top-header"
              : "top-header-no-height"
          }
        >
          {/* desktop */}
          <Container className="d-none d-lg-block">
            <Navbar className="custom-navbar" expand="lg">
              <NavbarBrand
                id="nav-brand"
                className={`${
                  this.props.location.pathname == "/games"
                    ? "active"
                    : "special"
                }`}
                tag={Link}
                to="/"
              >
                Logo
              </NavbarBrand>
              <NavbarToggler
                style={{ zIndex: 10 }}
                onClick={this.toggleNav}
                className="text-white-1"
              >
                {/* <i className="fa fa-bars"></i> */}
                <CgMenuRight id="navbar-toggler" className="text-white" />
              </NavbarToggler>
              <Collapse
                style={{ zIndex: 10 }}
                className=""
                isOpen={this.state.navbarCollapse}
                navbar
              >
                <Nav className="ms-auto" navbar>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/games"
                      className={`${
                        this.props.location.pathname == "/games"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Games
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/gallery"
                      className={`${
                        this.props.location.pathname == "/gallery"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Gallery
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/team-building"
                      className={`${
                        this.props.location.pathname == "/team-building"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Team Building Activities{" "}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/contact"
                      className={`${
                        this.props.location.pathname == "/contact"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Contact Us
                    </NavLink>
                  </NavItem>

                  {this.getUser() != null && (
                    <NavItem className="position-relative">
                      <NavLink
                        onClick={this.toggle}
                        // onBlur={this.toggle}
                        tag={Link}
                        to="#"
                        className={`d-flex align-items-center ${
                          this.props.location.pathname == "/profile"
                            ? "active"
                            : "special"
                        }`}
                      >
                        <span className="navbar-avatar me-1">
                          <img
                            style={{ width: "30px", height: "30px" }}
                            src={
                              this.getUser()["profile_img"]
                                ? this.getUser()["profile_img"]
                                : navbar_profile
                            }
                          />
                        </span>
                        {this.getUser()["full_name"]}
                        {!this.state.profile ? (
                          <i className="ms-3 fa fa-angle-down"></i>
                        ) : (
                          <i className="ms-3 fa fa-angle-up"></i>
                        )}
                      </NavLink>
                      <ul
                        className={`${
                          !this.state.profile ? "d-none" : "d-block"
                        }
                         custom-dropdown-navbar`}
                        style={{ zIndex: 10 }}
                      >
                        <Link className="custom-dropdown-item" to="/my-games">
                          My Games
                        </Link>
                        <Link className="custom-dropdown-item" to="/fav-games">
                          Favorite Games
                        </Link>
                        <Link className="custom-dropdown-item" to="/profile">
                          Settings
                        </Link>
                        <Link
                          className="custom-dropdown-item"
                          onClick={this.props.logout}
                        >
                          Sign Out
                        </Link>
                      </ul>
                    </NavItem>
                  )}

                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/cart"
                      className={`position-relative ${
                        this.props.location.pathname == "/cart"
                          ? "active"
                          : "special"
                      }`}
                    >
                      <i className="fa fa-shopping-cart" src={shopping_cart} />

                      <span
                        className="position-relative badge bg-dark"
                        style={{ top: -10, left: 5 }}
                      >
                        {this.noOfItemsInCart()}
                      </span>
                    </NavLink>
                  </NavItem>
                  {/* <NavItem>
                    <div id="google_translate_element"></div>
                  </NavItem> */}
                  {this.getUser() == null && (
                    <NavItem>
                      <NavLink
                        tag={Link}
                        to="/login"
                        className="bg-purple-1 text-white-1 btn"
                      >
                        Sign In
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
              </Collapse>
            </Navbar>
            {this.props.bread == null && (
              <Breadcrumb className="custom-breadcrumb">
                {this.props.path ? (
                  this.props.path == "-1" ? (
                    ""
                  ) : (
                    this.props.path.map((path, key) => (
                      <BreadcrumbItem key={`${path}${key}`}>
                        <Link
                          className="link-white text-white-1 text-decoration-none"
                          to={path == "Home" ? "/" : "#"}
                        >
                          {path}
                        </Link>
                      </BreadcrumbItem>
                    ))
                  )
                ) : (
                  <BreadcrumbItem>Home</BreadcrumbItem>
                )}
              </Breadcrumb>
            )}
            {this.props.heading && (
              <h2 className="text-white-1 header-heading">
                {this.props.heading}
              </h2>
            )}
          </Container>
          {/* mobile */}
          <Container className=" d-lg-none">
            <Navbar className="custom-navbar" expand="lg">
              <NavbarToggler
                style={{ zIndex: 10 }}
                onClick={this.toggleNav}
                className="text-white-1"
              >
                {/* <i className="fa fa-bars"></i> */}
                <CgMenuLeft id="navbar-toggler" className="text-white" />
              </NavbarToggler>
              <Collapse
                style={{ zIndex: 10 }}
                className=""
                isOpen={this.state.navbarCollapse}
                navbar
              >
                <Nav className="ms-auto" navbar>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/games"
                      className={`${
                        this.props.location.pathname == "/games"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Games
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/gallery"
                      className={`${
                        this.props.location.pathname == "/gallery"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Gallery
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/team-building"
                      className={`${
                        this.props.location.pathname == "/team-building"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Team Building Activities{" "}
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      tag={Link}
                      to="/contact"
                      className={`${
                        this.props.location.pathname == "/contact"
                          ? "active"
                          : "special"
                      }`}
                    >
                      Contact Us
                    </NavLink>
                  </NavItem>

                  {this.getUser() != null && (
                    <NavItem className="position-relative">
                      <NavLink
                        onClick={this.toggle}
                        // onBlur={this.toggle}
                        tag={Link}
                        to="#"
                        className={`d-flex align-items-center ${
                          this.props.location.pathname == "/profile"
                            ? "active"
                            : "special"
                        }`}
                      >
                        <span className="navbar-avatar me-1">
                          <img
                            style={{ width: "30px", height: "30px" }}
                            src={
                              this.getUser()["profile_img"]
                                ? this.getUser()["profile_img"]
                                : navbar_profile
                            }
                          />
                        </span>
                        {this.getUser()["full_name"]}
                        {!this.state.profile ? (
                          <i className="ms-3 fa fa-angle-down"></i>
                        ) : (
                          <i className="ms-3 fa fa-angle-up"></i>
                        )}
                      </NavLink>
                      <ul
                        className={`${
                          !this.state.profile ? "d-none" : "d-block"
                        }
                         custom-dropdown-navbar`}
                        style={{ zIndex: 10 }}
                      >
                        <Link className="custom-dropdown-item" to="/my-games">
                          My Games
                        </Link>
                        <Link className="custom-dropdown-item" to="/fav-games">
                          Favorite Games
                        </Link>
                        <Link className="custom-dropdown-item" to="/profile">
                          Settings
                        </Link>
                        <Link
                          className="custom-dropdown-item"
                          onClick={this.props.logout}
                        >
                          Sign Out
                        </Link>
                      </ul>
                    </NavItem>
                  )}

                  {/* <NavItem>
                    <div id="google_translate_element"></div>
                  </NavItem> */}
                  {this.getUser() == null && (
                    <NavItem>
                      <NavLink
                        tag={Link}
                        to="/login"
                        className="bg-purple-1 text-white-1 btn"
                      >
                        Sign In
                      </NavLink>
                    </NavItem>
                  )}
                </Nav>
              </Collapse>
              <NavbarBrand
                id="nav-brand"
                className={`${
                  this.props.location.pathname == "/games"
                    ? "active"
                    : "special"
                }`}
                tag={Link}
                to="/"
              >
                Logo
              </NavbarBrand>
              <NavItem>
                <NavLink
                  tag={Link}
                  to="/cart"
                  className={`position-relative ${
                    this.props.location.pathname == "/cart"
                      ? "active"
                      : "special"
                  }`}
                >
                  <i className="fa fa-shopping-cart" src={shopping_cart} />

                  <span
                    className="position-relative badge bg-dark"
                    style={{ top: -10, left: 5 }}
                  >
                    {this.noOfItemsInCart()}
                  </span>
                </NavLink>
              </NavItem>
            </Navbar>
            {this.props.bread == null && (
              <Breadcrumb className="custom-breadcrumb">
                {this.props.path ? (
                  this.props.path == "-1" ? (
                    ""
                  ) : (
                    this.props.path.map((path, key) => (
                      <BreadcrumbItem key={`${path}${key}`}>
                        <Link
                          className="link-white text-white-1 text-decoration-none"
                          to={path == "Home" ? "/" : "#"}
                        >
                          {path}
                        </Link>
                      </BreadcrumbItem>
                    ))
                  )
                ) : (
                  <BreadcrumbItem>Home</BreadcrumbItem>
                )}
              </Breadcrumb>
            )}
            {this.props.heading && (
              <h2 className="text-white-1 header-heading">
                {this.props.heading}
              </h2>
            )}
          </Container>
        </header>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    game: state.game,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Header);
